import { Link } from "react-router-dom";

const COLUMNS = [
  {
    title: "Explore",
    links: [
      { label: "Home", to: "/" },
      { label: "About DELSHA", to: "/about" },
      { label: "Contact & Support", to: "/support" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms and Conditions", to: "/terms" },
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Refund Policy", to: "/refund" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-slate-200/80 bg-slate-50">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <img
            src="/assets/delsha-wordmark.png"
            alt="DELSHA"
            className="h-8 w-auto"
          />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-600">
            The driving lesson booking app that connects learner drivers with
            driving instructors. Find. Book. Learn.
          </p>
          <p className="mt-4 font-mono text-xs uppercase tracking-widest text-blue-600">
            App Store &amp; Google Play links coming soon
          </p>
        </div>
        {COLUMNS.map((col) => (
          <div key={col.title}>
            <h3 className="font-display text-sm font-semibold uppercase tracking-wider text-slate-900">
              {col.title}
            </h3>
            <ul className="mt-4 space-y-3">
              {col.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-+$/, "")}`}
                    className="text-sm text-slate-600 transition-colors duration-200 hover:text-blue-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-slate-200/80 pt-6 sm:flex-row sm:items-center">
        <p className="text-xs text-slate-500">
          © {new Date().getFullYear()} DELSHA. All rights reserved.
        </p>
        <p className="text-xs text-slate-500">Find. Book. Learn.</p>
      </div>
    </div>
  </footer>
);
